import { render, staticRenderFns } from "./skindetection.vue?vue&type=template&id=5188293c&scoped=true"
import script from "./skindetection.vue?vue&type=script&lang=js"
export * from "./skindetection.vue?vue&type=script&lang=js"
import style0 from "./skindetection.vue?vue&type=style&index=0&id=5188293c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188293c",
  null
  
)

export default component.exports